import React from "react";

const Vehiclesevenyeartb = ({ data = [], lobName }) => {
    const tableData = data?.result || data; // in case your API wraps it under `result`

    if (!tableData || tableData.length === 0) {
        return (
            <div className="text-gray-500 text-center py-4">
                No vehicle data available for <strong>{lobName}</strong>.
            </div>
        );
    }

    return (
        <div className="overflow-x-auto border border-blue-400 rounded-lg shadow-sm mt-4">
            <table className="min-w-full bg-white rounded-lg">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-left">Sr No</th>
                        <th className="px-4 py-2 text-left">Asset Number</th>
                        <th className="px-4 py-2 text-left">Vehicle Reg. No.</th>
                        <th className="px-4 py-2 text-left">PL</th>
                        <th className="px-4 py-2 text-left">PPL</th>
                        <th className="px-4 py-2 text-left">Age (Years)</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((item, i) => (
                        <tr
                            key={i}
                            className={`${i % 2 === 0 ? "bg-white" : "bg-blue-50"
                                } hover:bg-blue-100`}
                        >
                            <td className="px-4 py-2 border-t border-blue-200">{item.sr_no}</td>
                            <td className="px-4 py-2 border-t border-blue-200">{item.assetNumber}</td>
                            <td className="px-4 py-2 border-t border-blue-200">{item.vehicleRegNumber}</td>
                            <td className="px-4 py-2 border-t border-blue-200">{item.pl}</td>
                            <td className="px-4 py-2 border-t border-blue-200">{item.ppl}</td>
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {item.ageInYears}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Vehiclesevenyeartb;
